import XLSX from 'xlsx'

export const QUESTION_EXPORT_HEADERS = [
  { key: 'alias', text: '风险名称' },
  { key: 'question', text: '问题' },
  { key: 'risk_answer', text: '风险答案' },
]

export function buildQuestionExportRows (questions) {
  return (questions || []).map((item) => ({
    alias: item.alias || '',
    question: item.question || '',
    risk_answer: item.risk_answer || '',
  }))
}

function normalizeHeader (value) {
  return String(value == null ? '' : value).replace(/\s+/g, '').trim()
}

function pickCell (row, keys) {
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if (Object.prototype.hasOwnProperty.call(row, key) && row[key] != null && String(row[key]).trim() !== '') {
      return String(row[key]).trim()
    }
  }
  return ''
}

/**
 * 解析问题导入 Excel，返回 { questions, error }
 * 顺序按 Excel 数据行从上到下；忽略「序号」列（若存在）
 * questions 项：{ alias, question, risk_answer }
 */
export function parseQuestionImportWorkbook (arrayBuffer) {
  const workbook = XLSX.read(arrayBuffer, { type: 'array' })
  if (!workbook.SheetNames || !workbook.SheetNames.length) {
    return { questions: [], error: 'Excel 文件为空' }
  }

  const worksheet = workbook.Sheets[workbook.SheetNames[0]]
  const rows = XLSX.utils.sheet_to_json(worksheet, { defval: '' })
  if (!rows.length) {
    return { questions: [], error: '未解析到有效数据行，请确认首行为表头' }
  }

  const headerMap = {}
  Object.keys(rows[0] || {}).forEach((rawKey) => {
    const normalized = normalizeHeader(rawKey)
    if (normalized === '风险名称' || normalized === '别名' || normalized.toLowerCase() === 'alias') {
      headerMap.alias = rawKey
    } else if (normalized === '问题' || normalized === '问题内容' || normalized.toLowerCase() === 'question') {
      headerMap.question = rawKey
    } else if (normalized === '风险答案' || normalized.toLowerCase() === 'risk_answer') {
      headerMap.risk_answer = rawKey
    }
  })

  if (!headerMap.alias || !headerMap.question || !headerMap.risk_answer) {
    return {
      questions: [],
      error: '表头需包含：风险名称、问题、风险答案',
    }
  }

  const questions = []
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i]
    const alias = pickCell(row, [headerMap.alias])
    const question = pickCell(row, [headerMap.question])
    const riskAnswer = pickCell(row, [headerMap.risk_answer])
    if (!alias && !question && !riskAnswer) {
      continue
    }
    questions.push({
      alias,
      question,
      risk_answer: riskAnswer,
    })
  }

  if (!questions.length) {
    return { questions: [], error: '未解析到有效问题，请检查数据行' }
  }

  return { questions, error: '' }
}

export function readFileAsArrayBuffer (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => resolve(e.target.result)
    reader.onerror = () => reject(new Error('文件读取失败'))
    reader.readAsArrayBuffer(file)
  })
}



// WEBPACK FOOTER //
// ./src/views/audio-asr-check/audio-asr-check.question-io.js